import { Button, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { MandateGeneralDto } from '../../../services/dtos/mandate-general.dto';
import { FileDto } from '../../../services/dtos/file.dto';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { MandateEstablishmentDto } from '../../../services/dtos/mandate-establishment-dto';
import { MandateTerritoryDto } from '../../../services/dtos/mandate-territory.dto';
import ProposalsAssignmentsUi from './proposal-assignment.ui';
import InterventionsUi from './interventions.ui';

/**
 * Ui de l'onglet decision & decomposition
 * @constructor
 */
export default function AssignmentsUi(
    props: Readonly<{
        mandate: MandateGeneralDto | MandateEstablishmentDto | MandateTerritoryDto;
    }>
) {
    // Gestion du dialog pour le signalement de changements
    const [file, setFile] = useState<FileDto>();
    // Gestion du dialog pour le signalement de changements
    const [confirmationProposalAssignment, setConfirmationProposalAssignment] = useState<boolean>(true);
    //const label
    const labelDocAssignment: string = 'doc-assignments';

    // Permet de télécharger un document de la réunion
    const handlerDownloadFile = (paramFile: FileDto) => {
        if (!paramFile.content) {
            return;
        }
        const fileURL = globalThis.URL.createObjectURL(paramFile.content);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = paramFile.name;
        document.body.appendChild(link);
        link.click();
        link.remove();
        globalThis.URL.revokeObjectURL(fileURL);
    };

    // Permet de visualiser un document de la réunion
    const handlerOpenFile = (paramFile: FileDto | undefined) => {
        setFile(paramFile);
    };

    const handleConfirmationProposalAssignment = () => {
        setConfirmationProposalAssignment(!confirmationProposalAssignment);
    };

    //Retourne la vue
    return file === undefined ? (
        <Grid container className={'assignments-ui'} rowSpacing={1}>
            {/*On affiche le tableau pour les décisions*/}
            <Grid item xs={12}>
                <ProposalsAssignmentsUi
                    mandate={props.mandate}
                    handlerDownloadFile={handlerDownloadFile}
                    handlerOpenFile={handlerOpenFile}
                    handleConfirmationProposalAssignment={handleConfirmationProposalAssignment}
                    confirmationProposalAssignment={confirmationProposalAssignment}
                />
            </Grid>
            {/*On affiche le tableau pour les deliberation*/}
            <Grid item xs={12}>
                <InterventionsUi
                    confirmationProposalAssignment={confirmationProposalAssignment}
                    mandate={props.mandate}
                />
            </Grid>
        </Grid>
    ) : (
        <Grid container className={'assignments-ui'} sx={{ marginLeft: '30px' }} rowSpacing={1}>
            {/*On affiche le tableau pour les décisions*/}
            <Grid
                item
                xs={12}
                sx={{
                    width: '80%',
                    display: 'flex',
                }}
            >
                {/* Bouton retour */}
                <Button
                    variant={'contained'}
                    sx={{
                        textAlign: 'center',
                        marginLeft: '10%',
                    }}
                    onClick={() => handlerOpenFile(undefined)}
                >
                    <FormatListBulletedIcon sx={{ marginRight: '5px' }} />
                    <Typography variant="body1" sx={{ color: '#fff' }}>
                        Afficher la liste des documents
                    </Typography>
                </Button>
            </Grid>
            {/*On affiche le tableau pour les deliberation*/}
            <Grid
                item
                xs={12}
                sx={{
                    marginBottom: '20px',
                    height: '100vh',
                    width: '80%',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <object
                    aria-label={labelDocAssignment}
                    data-testid={labelDocAssignment}
                    className={labelDocAssignment}
                    style={{ height: 'inherit', width: 'inherit' }}
                    data={file.data}
                ></object>
            </Grid>
        </Grid>
    );
}
